// Reconnecting WS client. Cookie (bbsessionhash) auto-sent on the upgrade.
import type { SrvMsg, CliMsg } from './protocol';

export type ConnState = 'connecting' | 'open' | 'closed';

export class WS {
    private sock: WebSocket | null = null;
    private url: string;
    private closed = false;
    onmsg: (m: SrvMsg) => void = () => {};
    onstate: (s: ConnState) => void = () => {};

    constructor() {
        const proto = location.protocol === 'https:' ? 'wss' : 'ws';
        // dev convenience: ?dev_uid=N is honored only when the server enables it
        const dev = new URLSearchParams(location.search).get('dev_uid');
        this.url = `${proto}://${location.host}/profilepets/ws${dev ? `?dev_uid=${dev}` : ''}`;
        this.connect();
    }

    private connect(): void {
        this.onstate('connecting');
        const s = new WebSocket(this.url);
        this.sock = s;
        s.onopen = () => this.onstate('open');
        s.onmessage = (e) => { try { this.onmsg(JSON.parse(e.data)); } catch { /* ignore */ } };
        s.onclose = () => { this.onstate('closed'); if (!this.closed) setTimeout(() => this.connect(), 1200); };
        s.onerror = () => { try { s.close(); } catch { /* */ } };
    }

    send(m: CliMsg): void { if (this.sock && this.sock.readyState === WebSocket.OPEN) this.sock.send(JSON.stringify(m)); }
    close(): void { this.closed = true; try { this.sock?.close(); } catch { /* */ } }
}
